import React from 'react';
import { connect } from 'react-redux';
import GoogleMapsLink from 'modules/Common/GoogleMapsLink';
import { DistanceCell } from 'modules/Common/Details';

import { getJobDetail } from 'redux/modules/job-detail/selectors';

import { Flexer } from '@ontruck/orc';

import { SectionTitleStyled, CardsContainerStyled } from 'modules/detail/styled';

import StopCards from 'modules/Stop/Cards';

import {
  openUploadCargoManifest as openUploadCargoManifestEffect,
  openDeleteCargoManifest as openDeleteCargoManifestEffect,
  updateStopTimes as updateStopTimesEffect,
} from 'redux/modules/job-detail/effects';

const t = {
  title: 'Stops',
};

const StopsSection = ({
  fetching,
  journey,
  openUploadCargoManifest,
  openDeleteCargoManifest,
  updateStopTimes,
  updatingTimes,
}) => {
  return (
    <>
      <SectionTitleStyled mBottom="S">
        {!fetching && !!journey ? (
          <>
            {(journey.stops || []).length} {t.title}, {}
            <DistanceCell {...journey} /> {}
            <Flexer.Parent inline mLeft="S">
              <GoogleMapsLink item={journey} skin="light" showDistance={false} />
            </Flexer.Parent>
          </>
        ) : (
          t.title
        )}
      </SectionTitleStyled>
      <CardsContainerStyled>
        {!fetching && !!journey && (
          <StopCards
            item={journey}
            onUploadCargoManifestClick={openUploadCargoManifest}
            onDeleteCargoManifestClick={openDeleteCargoManifest}
            onUpdateStopTimes={updateStopTimes}
            updatingTimes={updatingTimes}
            shipperOrdersSkin={journey.shipper_orders_skin}
          />
        )}
      </CardsContainerStyled>
    </>
  );
};

export default connect(
  (state) => {
    const jobDetail = getJobDetail(state);
    return {
      journey: jobDetail.data,
      updatingTimes: jobDetail.updatingTimes,
    };
  },
  {
    openUploadCargoManifest: openUploadCargoManifestEffect,
    openDeleteCargoManifest: openDeleteCargoManifestEffect,
    updateStopTimes: updateStopTimesEffect,
  }
)(StopsSection);
